export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-path/index.js
// module id = 79
// module chunks = 0